import type {ReactElement} from 'react';
import React from 'react';
import {FontHeading} from '@Components/font-selector-panel/components/font-heading';
import {FontsList} from '@Components/font-selector-panel/components/fonts-list';
import type {OnSelectFontFamilyCallback} from '@Components/font-selector-panel/font-selector.types';
import type {FontData} from '@Libraries/font-library';
import {useAppSelector} from '@/hooks';

interface AllFontsSectionProps {
  className?: string;
  showHeading?: boolean;
  onSelectFontFamily?: OnSelectFontFamilyCallback;
  showUserFonts?: boolean;
  selectedFontFamily?: string;
  isSelectedFontLoading?: boolean;
}

export function AllFontsSection({
  className = '',
  showHeading = true,
  onSelectFontFamily = (): void => {},
  showUserFonts = false,
  selectedFontFamily = '',
  isSelectedFontLoading = false,
}: AllFontsSectionProps): ReactElement {
  const allFonts = useAppSelector((state) => {
    return state.fontSelector.pmwFonts as Array<FontData> | null;
  });
  const userFonts = useAppSelector((state) => {
    return state.fontSelector.userFonts as Array<FontData> | null;
  });

  const concatinate = (): Array<FontData> | null => {
    if (userFonts && allFonts) {
      return userFonts?.concat(allFonts);
    }
    return userFonts;
  };

  const prepFonts = (): ReactElement | null => {
    if (allFonts === null) {
      return null;
    }
    if (showUserFonts) {
      const concatinatedFonts = concatinate();
      return concatinatedFonts ? (
        <FontsList onSelectFontFamily={onSelectFontFamily} isSelectedFontLoading={isSelectedFontLoading} fontNames={concatinatedFonts} selectedFontFamily={selectedFontFamily} />
      ) : null;
    }
    return <FontsList onSelectFontFamily={onSelectFontFamily} isSelectedFontLoading={isSelectedFontLoading} fontNames={allFonts} selectedFontFamily={selectedFontFamily} />;
  };

  return (
    <ul className={`spacing-m-0 ${className}`}>
      {showHeading ? <FontHeading heading={window.i18next.t('pmwjs_all_fonts')} /> : null}
      {prepFonts()}
    </ul>
  );
}
